import { gql } from "@apollo/client";

export const postBloqueoBip = gql`
  mutation bloqueoBip {
    BloqueoBipResponse(input: $input)
      @rest(
        type: "BloqueoBipResponse"
        path: "/gateway/bip/usuario/deshabilitar"
        method: "POST"
      ) {
      transactionId
      message
    }
  }
`;
